import React from "react";
import styled from "styled-components";

import {
  IconCloud,
  IconCloudDownload,
  IconCloudCheck,
  IconCloudOff
} from "@americanbible/uikit";

import { OfflineState } from "../../../storage/typedefs/BibleOffline";

export const CloudIconContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-left: 8px;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const CloudIcon = function({ offlineState, onClick }) {
  let Icon = IconCloudDownload;
  let percentDownloaded = 0; // as an integer between 4 and 99 (inclusive)
  if (offlineState <= OfflineState.online_only) Icon = IconCloudOff;
  else if (offlineState <= OfflineState.failed) Icon = IconCloud;
  else if (offlineState === OfflineState.local) Icon = IconCloudCheck;
  else {
    percentDownloaded = offlineState; // between OfflineState.downloading and .local is percent finished
    // LATER draw percent complete circle around icon
    console.debug("Percent downloaded =", percentDownloaded);
  }
  const component = (
    <CloudIconContainer>
      <Icon onClick={() => onClick(offlineState)} />
    </CloudIconContainer>
  );
  return component;
};
